import React from 'react';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import CartTotal from '../../Cart/CartTotal';
import SearchInput from '../../Forms/SearchInput';
import Errors from '../../Errors/Errors';

export default class OrderBuilderProducts extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      search: '',
      loading: false,
    }

    this.onChangeSearch = this.onChangeSearch.bind(this);
  }

  render() {
    if (this.props.active_tab !== "products") {
      return null;
    }

    return (
      <div className="tab-pane active" id="products">
        <Errors errors={this.props.errors} />
        <div className="row">
          <div className="col-6">
            <SearchInput value={this.state.search} onChange={this.onChangeSearch} />
            {this.renderProducts()}
          </div>
          <div className="col-6">
            <CartTotal {...this.props} {...this.state} />
          </div>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  renderProducts(){
    const searchTerm = this.state.search.toLowerCase();
    const products = this.props.all_products.filter(product => product.name.toLowerCase().includes(searchTerm)).map((product, index) => {
      return(
        <button key={index} className="product" onClick={() => this.props.onAddProduct(product)}>
          <div className="product-details">
            <h3>{product.name}</h3>
          </div>
        </button>
      );
    });

    return(
      <div className="products">
        {products}
      </div>
    );
  }

  onChangeSearch(e) {
    this.setState({ search: e.target.value });
  }
};
